import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();
  const filters = ref({
    userId: {value: null},
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value?.userId.value != null) {
      params.userId = filters.value.userId.value;
    }
    return params;
  }

  return {
    filters,
    pageable,
    getQueryParams,
  }
}


